import { useEffect } from "react";
import { FeatureStatic } from "../../../../@types/statics/feature.static";
import usePermission from "../../../../hooks/usePermission";
import { FormCostCenter } from "../components/FormCostCenter";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import { useSyncActive } from "../../../../utils/useSyncActive";

export const CreateCostCenter: React.FC = () => {
  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.costCenter.id);

  const isSyncActive = useSyncActive();

  useEffect(() => {
    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }
  }, []);

  return (
    <div className={styles.createCostCenter}>
      <FormCostCenter pageType="create" isSyncActive={isSyncActive} />
    </div>
  );
};
